<template>
  <div>
    <div class="d-flex justify-content-end mb-2">
      <!-- <b-button :to=>contact Details</b-button> -->
      <b-button
        size="sm"
        class="mr-2"
        :disabled="!isValidPrimaryContact"
        @click="onSetPrimary"
      >Make Primary Contact</b-button>
      <b-button size="sm" @click="showAddEditContactModal()">Add Contact</b-button>
    </div>
    <grid
      has-edit
      has-pagination
      has-delete
      grid-id="contacts-grid"
      :fields="fields"
      :items="contacts"
      :filters="filtersObjArr"
      :get-items-function="getContactsData"
      :total-rows="paging.totalItems"
      :current-page="paging.pageNumber"
      :per-page="paging.pageSize"
      :sort-by="paging.sortBy"
      :no-records="'No associated contacts found'"
      :sort-order="paging.sortOrder"
      @click-row="onSelectContact"
      @edit="showAddEditContactModal($event)"
      @delete="onDeleteContact"
    />

    <!--  MODAL  -->
    <b-modal
      ref="addEditContactModal"
      :title="this.modalTitle"
      ok-title="Save Company Contact"
      size="xl"
      @ok="onSaveCompanyContactRecord"
    >
      <contact-form
        ref="contactForm"
        :company-id="companyId"
        :contact="contactObj"
        :update-company-contact="saveCompanyContactRecord"
        :contact-role-types="contactRoleTypes"
      ></contact-form>
    </b-modal>
  </div>
</template>

<script>
//import gridFields from '../../../../../fields';

import Grid from '@/shared/components/Grid';
import ContactForm from './Form';
import _ from 'lodash';
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';

export default {
  components: {
    Grid,
    ContactForm
  },
  props: ['companyId'],
  data() {
    return {
      fields: [
        { key: 'commands', label: '', tdClass: 'grid-commands-width-1' },
        { key: 'firstName', label: 'First Name' },
        { key: 'lastName', label: 'Last Name' },
        { key: 'workTitle', label: 'Title' },
        { key: 'workPhone1', label: 'Phone' },
        { key: 'workPhone2', label: 'Mobile' },
        { key: 'workEmail', label: 'Email' },
        { key: 'workDepartment', label: 'Department' },
        { key: 'location', label: 'Location' },
        { key: 'businessUnit', label: 'Business Unit' }
      ],
      selectedContact: 0,
      modalTitle: '',
      saveCompanyContactRecord: false,
      contactObj: {},
      filtersObjArr: [
        {
          type: 'search',
          name: '',
          placeholder: 'Search By First Name',
          fieldName: 'firstName'
        }
      ]
    };
  },
  computed: {
    ...mapGetters('contacts', ['contacts']),
    ...mapState('contacts', [
      'contacts',
      'primaryContact',
      'paging',
      'contactRoleTypes'
    ]),
    isValidPrimaryContact() {
      return (
        this.selectedContact != 0 && this.primaryContact != this.selectedContact
      );
    }
  },
  watch: {
    companyId: {
      handler() {
        this.getContacts({ companyId: this.companyId });
      }
    }
  },
  methods: {
    ...mapActions('contacts', [
      'getContacts',
      'setPrimaryContact',
      'deleteContact',
      'getContactRoleTypesData',
      'getCompanyBusinessUnitData',
      'getContactsLookupData',
      'resetContactPaging'
    ]),
    ...mapActions('account', ['getLookupPhoneTypesData']),
    onSelectContact(item) {
      this.selectedContact = this.selectedContact == item.id ? 0 : item.id;
    },
    onSetPrimary() {
      this.setPrimaryContact(this.selectedContact);
    },
    showAddEditContactModal(contact = {}) {
      let isEmptyContact = _.isEmpty(contact);
      this.modalTitle = isEmptyContact ? 'Add' : 'Edit';
      this.contactObj = isEmptyContact ? {} : contact;
      this.modalTitle += ' Company Contact';
      this.$refs['addEditContactModal'].show();
    },
    onSaveCompanyContactRecord(event) {
      console.log('Company ContactSaved');
      event.preventDefault();
      this.$refs.contactForm.$v.$touch();
      if (this.$refs.contactForm.$v.$invalid) {
        return;
      }
      this.$nextTick(() => {
        this.$refs.addEditContactModal.hide();
      });
      this.saveCompanyContactRecord = Date.now();
    },
    async getContactsData(data) {
      await this.getContacts({ companyId: this.companyId, ...data });
    },
    async onDeleteContact(data) {
      if (!data.isPrimary) {
        await this.deleteContact([data.id, this.companyId]);
      } else {
        this.$bvModal.msgBoxOk('Cannot delete a Primary Contact');
      }
    }
  },
  async created() {
    this.getContactRoleTypesData();
    this.getLookupPhoneTypesData();
    this.getCompanyBusinessUnitData(this.companyId);
    this.getContactsLookupData(this.companyId);
    this.resetContactPaging();
  }
};
</script>